import { render, staticRenderFns } from "./DoKoSpectators.vue?vue&type=template&id=11d22beb&"
import script from "./DoKoSpectators.vue?vue&type=script&lang=ts&"
export * from "./DoKoSpectators.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports